import React, { useMemo, useState } from "react";
import {
  FaFileAlt,
  FaSearch,
} from "react-icons/fa";


export default function ReportsPage() {


  const [search,setSearch] = useState("");



  const reports = [

    {
      id:1,
      title:"Slutrapport Projekt X",
      type:"Slutrapport",
      date:"Januari 2026",
      author:"Projektledning",
    },


    {
      id:2,
      title:"Delrapport 1",
      type:"Uppföljning",
      date:"September 2025",
      author:"Projektgruppen",
    },


    {
      id:3,
      title:"Ekonomisk rapport",
      type:"Ekonomi",
      date:"December 2025",
      author:"Administrationen",
    }

  ];



  const filteredReports = useMemo(()=>{

    return reports.filter(report =>

      (
        report.title +
        report.type +
        report.author

      )
      .toLowerCase()
      .includes(search.toLowerCase())

    );

  },[search]);



  return (

    <div className="
      min-h-screen
      bg-[#F8FAFA]
      px-6
      py-10
    ">


      <div className="
        mx-auto
        max-w-6xl
      ">


        <h1 className="
          text-3xl
          font-semibold
          text-neutral-900
        ">
          Rapporter
        </h1>


        <p className="
          mt-2
          text-neutral-600
        ">
          Samlad dokumentation och rapporter för projektet.
        </p>



        {/* SEARCH */}


        <div className="
          mt-8
          rounded-2xl
          border
          border-neutral-200
          bg-white
          p-4
        ">


          <div className="
            flex
            items-center
            gap-3
            rounded-xl
            border
            px-4
            py-3
          ">


            <FaSearch className="text-neutral-400"/>


            <input

              value={search}

              onChange={
                e=>setSearch(e.target.value)
              }

              placeholder="Sök rapport..."

              className="
                flex-1
                outline-none
              "

            />


          </div>


        </div>





        {/* REPORTS */}


        <div className="
          mt-8
          grid
          md:grid-cols-2
          gap-6
        ">


          {
            filteredReports.map(report=>(


              <div

                key={report.id}

                className="
                  rounded-2xl
                  border
                  border-neutral-200
                  bg-white
                  p-6
                  transition
                  hover:-translate-y-1
                  hover:border-[#3BAFA3]/40
                "

              >


                <div className="
                  flex
                  items-center
                  gap-4
                ">


                  <div className="
                    rounded-xl
                    bg-[#E8F7F5]
                    p-3
                    text-[#3BAFA3]
                  ">

                    <FaFileAlt/>

                  </div>



                  <div>

                    <h2 className="
                      font-semibold
                      text-neutral-900
                    ">

                      {report.title}

                    </h2>


                    <p className="
                      text-sm
                      text-neutral-500
                    ">

                      {report.type}

                    </p>


                  </div>


                </div>




                <div className="
                  mt-5
                  text-sm
                  text-neutral-600
                ">

                  <p>
                    Datum: {report.date}
                  </p>


                  <p>
                    Ansvarig: {report.author}
                  </p>


                </div>



                <button

                  className="
                    mt-5
                    rounded-xl
                    bg-[#3BAFA3]
                    px-4
                    py-2
                    text-sm
                    font-medium
                    text-white
                  "

                >

                  Visa rapport

                </button>


              </div>


            ))

          }


        </div>


      </div>


    </div>

  );

}